import { CRIME_RECOGNITION_PATH } from 'constants/paths'
import CrimeRecognitionPage from './components/CrimeRecognitionPage'

// Sync route definition
export default {
  path: CRIME_RECOGNITION_PATH,
  component: CrimeRecognitionPage
}
